// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"a85acbec","139":"1ae458db"}[chunkId] + ".chunk.js";
};